import { useEffect, useState } from "react";
import { mainColor } from "../../constants/colors";
import {
  MMSettingsAdminConnection,
} from "../inner/mmTypes";
import { changeBackground } from "../../hooks/onHover";
import { useAlertService } from "../../hooks/useAlertService";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

type Person = {
  id: string;
  role: string;
  name: string;
  pairs: string[];
};

const getUsers = async () => {
  const response = await fetch(
    "https://lukkypro.ru/api/v1/users/get_user_list",
    {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("authToken"),
        "Content-Type": "application/json",
      },
    }
  );

  return await response.json();
};

const createConnection = async (body: MMSettingsAdminConnection) => {
  const response = await fetch("https://lukkypro.ru/api/v1/connections/create", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error("Cant create connection");
  }

  return await response.json();
};

const checkUser = async () => {
  const response = await fetch("https://lukkypro.ru/api/v1/auth/get_user", {
    method: "GET",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  });

  if (!response.ok) {
    throw new Error("Cant get order book data");
  }

  return await response.json();
};

export default function AddPair() {
  const { showAlert } = useAlertService();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    exchange: "",
    pair_name: "",
    open_key: "",
    private_key: "",
    password: "",
    hidden: false,
    is_active: false,
    manager_id: "",
  });
  const [usersData, setUsersData] = useState(() => []);
  const [open, setOpen] = useState(false);
  const [managerId, setManagerId] = useState<string>("");

  const handleChange = (e: any) => {
    let { name, value, type, checked } = e.target;
    if (name == "exchange" || name == "pair_name") {
      value = value.toUpperCase();
    }
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    formData.manager_id = managerId;

    let res;
    try {
      res = await createConnection({
        exchange: formData.exchange,
        open_key: formData.open_key,
        private_key: formData.private_key,
        password: formData.password,
        hidden: formData.hidden,
        is_active: formData.is_active,
        pair_name: formData.pair_name,
        managers: [formData.manager_id],
      } as MMSettingsAdminConnection);
    } catch (error) {
      console.log(error);
      showAlert({
        type: "error",
        message: "Error.",
      });

      return;
    }

    if (!res.id) {
      showAlert({
        type: "error",
        message: "No id was received from server.",
      });

      return;
    }

    showAlert({
      type: "success",
      message: "Success.",
    });
  };

  useEffect(() => {
    (async () => {
      try {
        const user = await checkUser();
        console.log(user.role);
        setIsAdmin(user.role == "ADMIN");

        const res = await getUsers();
        setUsersData(res);
      } catch (error) {
        setIsAdmin(false);
      }
    })();
  }, []);

  const handleChangePopUp = (e: any) => {
    console.log(e.target.value);
    setManagerId(e.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (
    event: React.SyntheticEvent<unknown>,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const findManager = () => {
    const managerData = usersData.find((e: Person) => e.id == managerId);
    if (managerData) {
      return (managerData as Person).name;
    }
  };

  return (
    <div
      id="App"
      style={{
        display: "flex",
        background: mainColor,
        justifyContent: "center",
      }}
    >
      {isAdmin ? (
        <div
          id="page-wrap"
          className="m-auto py-24 rounded-[20px] shadow-[5px_10px_10px]"
          style={{
            width: "75vw",
            backgroundColor: "white",
            margin: "auto",
            padding: "20px 20px 20px 20px",
            border: "1px black solid",
            maxHeight: "75vh",
            overflowY: "auto",
          }}
        >
          <div className="m-auto mb-[50px]" style={{ textAlign: "center" }}>
            Create pair
          </div>
          <form style={formStyle}>
            <h3>Connection settings</h3>
            <div style={inputContainerStyle}>
              <label>Exchange</label>
              <input
                style={{ width: "30vw", textTransform: "uppercase" }}
                name="exchange"
                type="text"
                required
                value={formData.exchange}
                onChange={handleChange}
                placeholder="mexc"
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Pair name</label>
              <input
                style={{ width: "30vw", textTransform: "uppercase" }}
                name="pair_name"
                type="text"
                required
                value={formData.pair_name}
                onChange={handleChange}
                placeholder="btc/usdt"
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Open key</label>
              <input
                style={{ width: "30vw" }}
                name="open_key"
                type="text"
                required
                value={formData.open_key}
                onChange={handleChange}
                placeholder="mjxife192jps"
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Private key</label>
              <input
                style={{ width: "30vw" }}
                name="private_key"
                type="text"
                required
                value={formData.private_key}
                onChange={handleChange}
                placeholder="damsii12eiasdma12930j"
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Password</label>
              <input
                style={{ width: "30vw" }}
                name="password"
                type="text"
                value={formData.password}
                onChange={handleChange}
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Is hidden</label>
              <input
                style={{ width: "30vw" }}
                name="hidden"
                type="checkbox"
                checked={formData.hidden}
                onChange={handleChange}
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Is active</label>
              <input
                style={{ width: "30vw" }}
                name="is_active"
                type="checkbox"
                checked={formData.is_active}
                onChange={handleChange}
              />
            </div>
            <div style={inputContainerStyle}>
              <label>Manager ID</label>

              <Button
                style={{ border: "1px solid", width: "30vw", color: "black" }}
                onClick={handleClickOpen}
                onMouseOver={(e) => changeBackground(e, mainColor + "1A")}
                onMouseLeave={(e) => changeBackground(e, "transparent")}
              >
                {!managerId
                  ? "Select manager"
                  : `Selected manager is: ${findManager()}`}
              </Button>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Managers</DialogTitle>
                <DialogContent>
                  <Box
                    component="form"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <FormControl sx={{ m: 1, minWidth: 240 }}>
                      <InputLabel id="demo-dialog-select-label">
                        Manager
                      </InputLabel>
                      <Select
                        labelId="demo-dialog-select-label"
                        id="demo-dialog-select"
                        value={managerId}
                        onChange={handleChangePopUp}
                        input={<OutlinedInput label="Manager" />}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {usersData ? (
                          usersData.map((el: Person) => {
                            return (
                              <MenuItem value={el.id}>
                                {el.name} - {el.role}
                              </MenuItem>
                            );
                          })
                        ) : (
                          <div />
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
              </Dialog>
            </div>
            <button
              onMouseOver={(e) => changeBackground(e, mainColor + "1A")}
              onMouseLeave={(e) => changeBackground(e, "transparent")}
              onClick={(e) => handleSubmit(e)}
              className="cursor-pointer"
              style={{
                backgroundColor: "transparent",
                border: "1px solid black",
                borderRadius: "5px",
              }}
            >
              Save changes
            </button>
          </form>
        </div>
      ) : (
        <div
          id="page-wrap"
          className="m-auto py-24 rounded-[20px] shadow-[5px_10px_10px]"
          style={{
            width: "75vw",
            backgroundColor: "white",
            margin: "auto",
            padding: "20px 20px 20px 20px",
            border: "1px black solid",
            maxHeight: "75vh",
            overflowY: "auto",
          }}
        >
          <div style={inputContainerStyle}>Not allowed </div>
        </div>
      )}
    </div>
  );
}

const formStyle: React.CSSProperties = {
  //   display: "grid",
  //   gap: "1rem",
};

const inputContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
};
